import { createApp } from 'vue'
import './assets/fonts'
import './assets/style.css'
import './assets/styles/views/MyMapView-commune-theme.scss'
import App from './App.vue'
import { registerPlugins } from './plugins'

const app = createApp(App)

registerPlugins(app)
app.mount('#app')
